import { Component, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { UiTable } from "../../../components/ui/table/table.component";
import { TableBudgets } from "../../../data/schemas/table.schema";
import { ReportService } from "../../../services/report.service";
import { TypeInterventionService } from "../../../services/typeintervention/typeintervention.service";
import { ActivtieResponse } from "../../../data/http/responses/activite.response";
import { TypeInterventionResponse } from "../../../data/http/responses/typeintervention.response";
import { IActivite } from "../model/IActivite";
import { AppService } from '../../../core/app.service';
import { TypeActiviteResponse } from "../../../data/http/responses/typeactivite.response";
import { ActiviteForReportService } from "../../../services/activiteForReportService";
import { TypeActiviteService } from "../../../services/typeactivites/typeactivite.service";
import { ActiviteService } from "../../../services/activite/activite.service";
import { MatIcon } from "@angular/material/icon";
import { UiButtonComponent } from "../../../components/button/button.component";


@Component({
  templateUrl: "./budget.component.html",
  styleUrl: "./budget.component.css",
  selector: "BudgetPage",
  imports: [UiTable, MatIcon,UiButtonComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA] // ✅ nécessaire pour <iconify-icon>
})

export class BudgetPage {
  public tableColumnBudgets = TableBudgets
  public activities: ActivtieResponse[] = [];

  constructor(
    private structureProgrammatiqueService: ActiviteForReportService,
    private typeActiviteService: TypeActiviteService,
    private reportService: ReportService,
    private typeInterventionService: TypeInterventionService,
    private appService: AppService,
    private activiteService: ActiviteService
  ) { }
  public data: any[] = []

  public typeactivities: TypeActiviteResponse[] = [];
  public structures: ActivtieResponse[] = [];
  public activites: ActivtieResponse[] = [];
  public typeInterventionData: TypeInterventionResponse[] = [];
  ngOnInit(): void {
    this.loadTypeIntervention();;
    this.loadStructures();
    this.loadTypeActivite();
    this.loadActivities()
  }

  ajouterBudget(): void { /* A rajouter */}

  loadActivities(): void {
    this.structureProgrammatiqueService.getAllByAppId(this.appService.getAppId()).subscribe({
      next: (response) => {
        //console.log(response.data)
        const allActivities = response.data as ActivtieResponse[];

        // Filtrer les activités pour ne garder que celles avec MODEEXECUTION: PMP
        this.activities = allActivities.filter(activity =>
          activity.caracteristiques?.some(caracteristique =>
            caracteristique.code === 'MONTANT_ESTIMATIF' || caracteristique.code === 'MONTANTESTIMATIF'
          )
        );

        //console.log("Activités PMP chargées et filtrées:", this.activities);
      },
      error: (error) => {
        console.error("Erreur lors du chargement des activités", error);
      }
    })
  }

  loadStructures(): void {
    this.structureProgrammatiqueService.getAllByAppId(this.appService.getAppId()).subscribe({
      next: (response: any) => {
        this.activites = response.data ?? [];
        this.structures = this.activites.filter((activite) =>
          activite.typeActivite === "PROGRAMMES" || activite.typeActivite === "PROGRAMME"
        );
      },
      error: (error) => {
        console.error('Erreur lors du chargement des structures :', error);
      }
    });
  }


  loadTypeIntervention(): void {
    this.structureProgrammatiqueService.getAllByAppId(this.appService.getAppId()).subscribe({
      next: (response: any) => {
        this.typeInterventionData = response.data;
      },
      error: (error) => {
        console.error('Erreur lors du chargement des structures :', error);
      }
    });
  }


  loadTypeActivite(): void {
    this.typeActiviteService.getAllByAppId(this.appService.getAppId()).subscribe({
      next: (response: any) => {
        this.typeactivities = response.data;
      },
      error: (error) => {
        console.error('Erreur lors du chargement des structures :', error);
      }
    });
  }

  // Gestion des etat 
  /* --- Fonctions de génération de rapports --- */
  telechargerRapportPtabXlsx() {
    this.telechargerRapportPtab('xlsx')
  }

  // Gestion des etat 
  /* --- Fonctions de génération de rapports --- */
  private buildDataFromHierarchy(node: ActivtieResponse, path: string[] = []): void {
    const ref = path.join('.');
    if (ref) {
      this.toData(ref, node);
    }

    const children = node.taches ?? [];
    children.forEach((child, index) => {
      this.buildDataFromHierarchy(child, [...path, String(index + 1)]);
    });
  }

  telechargerRapportPtab(format = 'pdf') {
    try {
      this.data = [];

      const programmes = this.structures.length > 0 ? this.structures : this.activites.filter((activite) =>
        activite.typeActivite === "PROGRAMMES" || activite.typeActivite === "PROGRAMME"
      );

      programmes.forEach((programme, index) => {
        this.buildDataFromHierarchy(programme, [String(index + 1)]);
      });

      const parameters = {
        annee: 2026,
        objectif_general: "Améliorer l'efficacité, la célérité, la qualité et l'accessibilité des prestations sociales au profit des assurés."
      };
      if (this.data.length === 0) return;

      this.reportService.generatePtabReport(format, this.data, parameters).subscribe({
        next: (blob: Blob) => {
          if (format === 'pdf') {
            this.reportService.openOrDownloadReport(blob, `ptab.pdf`);
          } else {
            this.reportService.downloadReport(blob, `ptab.${format}`);
          }
        },
        error: (err: any) => console.error('Erreur téléchargement :', err)
      });
    } catch (error) {
      console.error('Erreur lors du téléchargement du rapport:', error);
    }
  }


  toData(ref: string, act: ActivtieResponse) {

    //console.log(" activite : " + act)
    let imput_budget: number = 0;
    let montant_estim: number = 0;
    let cout_prev: number = 0;
    let montant_dec: number = 0;
    let prev_dec: number = 0;
    let horizon: string = '';
    let coup_prev: number = 0;
    let poids: number = 0;
    let struc_res: string = '';
    let struc_asso: string = '';
    let superv: string = '';
    let mode_exec: string = '';
    let observation: string = '';
    let prev_dec_27: number = 0;

    act.caracteristiques?.forEach((caract) => {
      if ("SUPERVISOR".toUpperCase() === caract.code) {
        superv = caract.valeur;
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);
      } else if ("MODEEXECUTION".toUpperCase() === caract.code || "MODE_EXECUTION".toUpperCase() === caract.code) {
        mode_exec = caract.valeur;
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);
      } else if ("STRUCTASSOCIE".toUpperCase() === caract.code) {
        struc_asso = caract.valeur;
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);
      } else if ("STRUCTURERESPONSABLE".toUpperCase() === caract.code || "STRUCTURE_RESPONSABLE".toUpperCase() === caract.code) {
        struc_res = caract.valeur;
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);
      } else if ("MONTANT_ESTIMATIF".toUpperCase() === caract.code || "DECAISSEMENT_ESTIMATIF".toUpperCase() === caract.code) {
        montant_estim = isNaN(Number(caract.valeur)) ? 0 : Number(caract.valeur);
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);
      } else if ("IMPUTATIONBUDGETAIRE".toUpperCase() === caract.code || "IMPUTATION_BUDGETAIRE".toUpperCase() === caract.code) {
        imput_budget = isNaN(Number(caract.valeur)) ? 0 : Number(caract.valeur);
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);
      } else if ("HORIZON".toUpperCase() === caract.code) {
        horizon = caract.valeur;
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);
      } else if ("COUTPREVU2025".toUpperCase() === caract.code || "COUT_PREVU_N".toUpperCase() === caract.code) {
        cout_prev = isNaN(Number(caract.valeur)) ? 0 : Number(caract.valeur);
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);
      } else if ("COUTPREVU2026".toUpperCase() === caract.code || "COUT_PREVU_N1".toUpperCase() === caract.code) {
        coup_prev = isNaN(Number(caract.valeur)) ? 0 : Number(caract.valeur);
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);
      } else if ("PREVISIONDECAISSEMENTT4_2025" === caract.code || "PREVISION_DECAISSEMENT_T4_N" === caract.code) {
        prev_dec = isNaN(Number(caract.valeur)) ? 0 : Number(caract.valeur);
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);
      } else if ("PREVISIONDECAISSEMENT2027" === caract.code || "PREVISION_DECAISSEMENT_N2" === caract.code) {
        prev_dec_27 = isNaN(Number(caract.valeur)) ? 0 : Number(caract.valeur);
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);
      } else if ("MONTANTDECAISSEAU30SEPT2025".toUpperCase() === caract.code || "MONTANT_DECAISSE_AU30_SEPT_N" === caract.code) {
        montant_dec = isNaN(Number(caract.valeur)) ? 0 : Number(caract.valeur);
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);

      } else if ("POIDS".toUpperCase() === caract.code) {
        poids = isNaN(Number(caract.valeur)) ? 0 : Number(caract.valeur);
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);
      }
    });

    //console.log(" type : " + act.typeActivite)

    const activite: IActivite = {
      type: act.typeActivite,
      num: ref,
      objectifs: act.titre,
      imput_budget: imput_budget,
      montant_estim: montant_estim,
      cout_prev: cout_prev,
      montant_dec: montant_dec,
      prev_dec: prev_dec,
      horizon: horizon,
      coup_prev: coup_prev,
      poids: poids,
      struc_res: struc_res,
      struc_asso: struc_asso,
      superv: superv,
      mode_exec: mode_exec,
      observation: observation,
      prev_dec_27: prev_dec_27,
    };

    this.data.push({ ...activite });
  }
}